<sk-button
  [size]="'sm'"
  appearance="outlined"
  class="announcement-btn"
  data-test="new-functionality-exist-btn"
  [ngxTippy]="popoverTemplate"
  (click)="goToReleaseNotes($event)"
  [label]="'label.New' | translate">
</sk-button>

<ng-template #popoverTemplate>
  {{ config.customText ? (config.customText | irisTranslate: config.translations)?.customText ?? config.customText : 'label.ForMoreInfoClickBtn' | translate }}
</ng-template>
